import { RequestBuilder, fetchAndRetryIfServerBusy } from '@cvent/nucleus-networking';
import { SESSION_HEADER_EVENT_ID } from '../constants/Request';
import { ServiceError } from '../utils/errors';

/**
 * API client for User Text
 */
export default class UserTextClient {
  constructor(baseUrl, eventId, environment, authorizationToken) {
    this.baseUrl = `${baseUrl}multilanguage/`;
    this.environment = environment;
    this.eventId = eventId;
    this.requestBuilder = resource => new RequestBuilder({
      url: this.baseUrl + resource
    })
      .auth(authorizationToken)
      .withCookies()
      .header(SESSION_HEADER_EVENT_ID, eventId);
  }

  /**
   * Get user text for the localeId
   */
  getUserTextForLocale = async (localeId) => {
    const request = this.requestBuilder(this.eventId + '/usertext')
      .query('environment', this.environment)
      .query('locale', localeId)
      .get()
      .json()
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.status === 404) {
      return;
    } else if (!response.ok) {
      throw await ServiceError.create('get User Text failed', response, request);
    }
    const userTextResponse = await response.json();
    return userTextResponse;
  };
}
